import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMessageFromError } from "../../../shared/welda/services/utilsService";
import errorHandling from "../errorHandling";
import LabelsService from "./labelsService";

const initialState = {
  templates: [],
  labels: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const GetTemplates = createAsyncThunk(
  "labels/getTemplates",
  async (thunkAPI) => {
    try {
      const awaitGetTemplates = await LabelsService.GetTemplates();
      return awaitGetTemplates;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const NewTemplate = createAsyncThunk(
  "labels/NewTemplate",
  async (data, thunkAPI) => {
    try {
      const awaitNewTemplate = await LabelsService.NewTemplate(data);
      return awaitNewTemplate;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const UpdateTemplate = createAsyncThunk(
  "labels/UpdateTemplate",
  async (data, thunkAPI) => {
    try {
      const awaitUpdateTemplate = await LabelsService.UpdateTemplate(data);
      return awaitUpdateTemplate;
    } catch (error) {
      console.error(error);
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const DeleteTemplate = createAsyncThunk(
  "labels/DeleteTemplate",
  async (data, thunkAPI) => {
    try {
      const awaitDeleteTemplate = await LabelsService.DeleteTemplate(data);
      return awaitDeleteTemplate;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      //errorHandling(error)
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const labelsSlice = createSlice({
  name: "labels",
  initialState,
  reducers: {
    reset: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetTemplates.pending, (state) => {})
      .addCase(GetTemplates.fulfilled, (state, action) => {
        state.templates = action.payload;
      })
      .addCase(GetTemplates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(NewTemplate.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(NewTemplate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(NewTemplate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(UpdateTemplate.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(UpdateTemplate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(UpdateTemplate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(DeleteTemplate.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(DeleteTemplate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(DeleteTemplate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { reset } = labelsSlice.actions;
export default labelsSlice.reducer;
